import { Observable } from "rxjs";
import { DynamicInput, IDynamicInputOptions } from "../dynamic-input.model";
import { SwitchComponent } from "./switch.component";

export interface ISwitchOptions extends IDynamicInputOptions {
  name?: string;
  subLabel?: string;
  preceedingOffLabel?: string;
  followingOnLabel?: string;
  tooltip?: string;
  tooltipAllowHtml?: boolean;
  tooltipStyleClass?: string;
  tooltipLoader?(): Observable<string>;
}

export class Switch extends DynamicInput implements ISwitchOptions {
    name: string;
    subLabel: string;
    preceedingOffLabel: string;
    followingOnLabel: string;
    options: any[];
    tooltip: string;
    tooltipAllowHtml: boolean;
    tooltipStyleClass: string;

    readonly controlType = "switch";
    readonly componentType = SwitchComponent;

    constructor(options: ISwitchOptions = {}) {
      super(options);
      this.name = options.name || this.createRandomName();
      this.subLabel = options.subLabel;
      this.preceedingOffLabel = options.preceedingOffLabel;
      this.followingOnLabel = options.followingOnLabel;
      this.tooltip = options.tooltip;
      this.tooltipLoader = options.tooltipLoader;
      this.tooltipAllowHtml = options.tooltipAllowHtml || false;
      this.tooltipStyleClass = options.tooltipStyleClass || "";
    }

    tooltipLoader?: () => Observable<string>;

    private createRandomName = (): string => {
      return Math.random().toString(36).substr(2, 9);
    }
  }
